import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

export default function RightSlideModal({ isOpen, onClose, title, maxWidth = 'max-w-md', children }) {
  const [shouldRender, setShouldRender] = useState(isOpen);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      document.body.style.overflow = 'hidden';
      const timer = setTimeout(() => setAnimate(true), 10);
      return () => clearTimeout(timer);
    } else {
      setAnimate(false);
      document.body.style.overflow = '';
      const timer = setTimeout(() => setShouldRender(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!shouldRender) return null;

  return createPortal(
    <div
      className={`fixed inset-0 flex justify-end outline-none focus:outline-none transition-all duration-300 ${
        animate ? 'bg-black/40 backdrop-blur-sm' : 'bg-transparent backdrop-blur-0 pointer-events-none'
      }`}
      style={{ zIndex: 9999 }}
      onClick={onClose}
    >
      <div
        className={`bg-white w-full ${maxWidth} flex flex-col transform transition-transform duration-300 ease-out border-l border-slate-100 ${
          animate ? 'translate-x-0' : 'translate-x-full'
        }`}
        style={{
          height: '100dvh',
          boxShadow: '-8px 0 40px rgba(0,0,0,0.12)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          className="flex items-center justify-between px-6 py-5 shrink-0 border-b border-white/30"
          style={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(238,242,255,0.90) 50%, rgba(224,231,255,0.92) 100%)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            boxShadow: '0 1px 0 0 rgba(99,102,241,0.08), 0 4px 24px -4px rgba(99,102,241,0.06)',
          }}
        >
          <div className="flex items-center gap-3">
            <div className="w-1 h-6 rounded-full bg-gradient-to-b from-indigo-500 to-purple-500 opacity-80" />
            <h3 className="font-outfit font-bold text-lg text-slate-800 tracking-tight">{title}</h3>
          </div>
          <button
            onClick={onClose}
            className="p-1.5 rounded-xl text-slate-400 hover:text-slate-700 hover:bg-indigo-50 active:scale-90 transition-all outline-none border border-transparent hover:border-indigo-100"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Scrollable content — min-h-0 critical for flex overflow */}
        <div className="flex-1 overflow-y-auto p-6 min-h-0">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
}

